// @flow
import * as React from 'react';
import NotFoundContent from 'components/NotFoundContent';
import Layout from 'layouts/Layout';
import { setDocumentTitle } from 'utils/meta';
import Box from 'components/Box';
import { maxWidth, gutterWidth } from 'theme';

const { useEffect } = React;

const NotFoundPage = ({
  searchText,
  searchUrl
}: {
  searchText?: string,
  searchUrl?: string
}) => {
  useEffect(() => {
    /* TRANSLATORS: 404 page title */
    setDocumentTitle(getText('Page Not Found'));
  }, []);

  return (
    <Layout>
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        p={[gutterWidth / 2, null, null, gutterWidth]}
      >
        <NotFoundContent searchText={searchText} searchUrl={searchUrl} />
      </Box>
    </Layout>
  );
};

export default NotFoundPage;
